<div class="scenario" fxFlexFill fxLayout="column">
  <mat-toolbar color="accent" fxLayout="row">
    <button type="button"
            mat-fab color="primary"
            matTooltip="Add Mortgage"
            (click)="addMortgage()">+M
    </button>
    <div fxFlex="1 1 auto" fxLayoutAlign="center center">
      <h1 fxFlex="nogrow">Scenario {{scenarioId}}</h1>
    </div>
    <button
      type="button"
      mat-fab color="accent"
      class="justify-content-end"
      matTooltip="Remove Scenario"
      (click)="remove()">-S
    </button>
  </mat-toolbar>

  <div class="scenario-overview" fxLayout="row">
    <div fxFlex="80">
      <mortgagegraph-tag [showLog]="showLog$|async" [lines]="mortgagesLineData$|async"
                         *ngIf="mortgagePresent$|async"></mortgagegraph-tag>
    </div>
    <div fxLayout="column" fxFlex="20">
      <div fxLayoutGap="10px" fxLayoutAlign="start center">
        <mat-slide-toggle [checked]="showLog$|async"
                          (change)="submitShowLog($event.checked);"></mat-slide-toggle>
        <mat-label >Show log</mat-label>
      </div>
      <form (submit)="submit($event)" fxLayoutGap="10px" fxLayout="row" fxLayoutAlign="start center" >
        <mat-slide-toggle [checked]="useInflationCorrection$|async"
                          (change)="submitUseInflationCorrection($event.checked);"></mat-slide-toggle>
        <mat-label>Inflation</mat-label>
        <mat-form-field fxFlex="3.5em">
                      <mat-label> rate</mat-label>
          <input matInput id="inflation-rate" value="{{inflationRate$|async}}"
                 (blur)="submitChangeInflationRate(toNumber($event.target.value))"
                 (keyup.enter)="submitChangeInflationRate(toNumber($event.target.value))"
          />
          <span matSuffix>%</span>
        </mat-form-field>
      </form>
      <div class="scenario-summary" fxFlex="auto" fxLayoutAlign="center start">
        <mortgagesummary-tag [scenario]="scenario$|async"
                             [useInflationCorrection]="useInflationCorrection$|async"></mortgagesummary-tag>
      </div>
    </div>
  </div>
  <div class="Mortgages" fxLayout="column">
    <div *ngFor="let mortgage of mortgages$| async | keyvalue">
      <mat-card>
        <mat-card-content>
          <mortgage-details [mortgage]="mortgage.value" [scenarioId]="scenarioId"></mortgage-details>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>

<mat-divider></mat-divider>
